import XhrRequestHandler from '../../lib/XhrRequestHandler';
import {
  PlanillaPartidoReglaJugadorDisponibleCategoriasInferior,
  PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON,
} from './PlanillaPartidoReglaJugadorDisponibleCategoriasInferior';
export class PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorSystem {
  private readonly base = '/planillapartidoreglajugadordisponiblecategoriasinferiors';
  constructor(private requestHandler: XhrRequestHandler) {}

  async getPlanillaPartidoReglaJugadorDisponibleCategoriasInferiorIdentifiedBy(
    id: string
  ): Promise<PlanillaPartidoReglaJugadorDisponibleCategoriasInferior> {
    const data = await this.requestHandler.get<PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON>(
      `${this.base}/${id}`
    );
    return PlanillaPartidoReglaJugadorDisponibleCategoriasInferior.fromJSON(data);
  }

  async getList(): Promise<PlanillaPartidoReglaJugadorDisponibleCategoriasInferior[]> {
    const data = await this.requestHandler.get<PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON[]>(
      `${this.base}`
    );
    return data.map((entity) => PlanillaPartidoReglaJugadorDisponibleCategoriasInferior.fromJSON(entity));
  }

  async getRulesFor(torId: string): Promise<PlanillaPartidoReglaJugadorDisponibleCategoriasInferior[]> {
    const data = await this.requestHandler.get<PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON[]>(
      `${this.base}/rules-for/${torId}`
    );
    return data.map((entity) => PlanillaPartidoReglaJugadorDisponibleCategoriasInferior.fromJSON(entity));
  }

  async getListForDropdown(): Promise<PlanillaPartidoReglaJugadorDisponibleCategoriasInferior[]> {
    const data = await this.requestHandler.get<PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON[]>(
      `${this.base}/for-dropdown`
    );
    return data.map((entity) => PlanillaPartidoReglaJugadorDisponibleCategoriasInferior.fromJSON(entity));
  }

  async save(entity: PlanillaPartidoReglaJugadorDisponibleCategoriasInferior) {
    const data = entity.toJSON();
    const savedEntity = await this.requestHandler.post<
      PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON,
      PlanillaPartidoReglaJugadorDisponibleCategoriasInferiorJSON
    >(this.base, data);
    return PlanillaPartidoReglaJugadorDisponibleCategoriasInferior.fromJSON(savedEntity);
  }

  getBaseUrlForDatagrid() {
    return this.requestHandler.requestUrl(`${this.base}/datagrid`);
  }
}
